// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__2kyP7","success":"AnswerItem_success__38iR-","error":"AnswerItem_error__39RFW"};